import { transliterate } from 'transliteration';

export default function (items, text) {
  const visibleItems = items.filter((element) => {
    let sector = element.tags[0];
    let institution = element.tags[1];
    if (sector != null) {
      sector = sector.toLowerCase();
    }
    if (institution != null) {
      institution = institution.toLowerCase();
    }

    let searchTarget = `${element.title.toLowerCase()} ${sector} ${institution}`;
    searchTarget = transliterate(searchTarget);
    return searchTarget.indexOf(transliterate(text.toLowerCase())) !== -1;
  });
  return visibleItems;
}
